<template>
    <page>

    <head-nav :title="$t('language.page_chatpersons')">
      <icon-button-hamburger slot="left"></icon-button-hamburger>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

  
    <scroll-page :pull-reload="true">


    <page-padding v-if="computeUserAccess">
      <!--<button-action  :to="'/group/'+group_id+'/absence/add_item/'" title="language.new_call_sick" ></button-action>-->
   </page-padding>


    <list-chat-persons/>

     </scroll-page>
    </page>
</template>

<script>

import { mapState } from 'vuex';

import PagePadding from '../components/PagePadding.vue';
import ScrollPage from '../components/ScrollPage.vue';
import Page from '../pages/Page';
import HeadNav from '../components/HeadNav';
import IconButtonHome from '../components/buttons/IconButtonHome';
import IconButtonHamburger from '../components/buttons/IconButtonHamburger';
import { USER_LEVEL } from '../settings/USER_LEVEL';
import ListChatPersons from '../components/chat/ListChatPersons.vue';


export default {
  name: 'global-chatpersons-page',
  data:function(){
    return {
      group_id:this.$route.params.id,
    }
  },
  methods:{
    
   

  },
  computed:{
     ...mapState([
       'groups','appSettings','group',
       ]),
       computeUserAccess(){
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return false;
         }
         return false;
       }
  },
  components:{
    ScrollPage,
    PagePadding,
    //ButtonAction,
    ListChatPersons,
    Page,
    HeadNav,
    IconButtonHome,
    IconButtonHamburger,
  },
  created(){
  },
  mounted(){
  },
  beforeDestroy(){
  }
  
  
}




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
